<template>
    <div id="product-base" class="data-list-container">

        <div class="vx-row" v-if="userInfo.type_id === 3" style="margin-top: -50px;">
            <div class="vx-col w-full">
                <download-excel
                    class   = "btn btn-default"
                    :data   = "json_data"
                    worksheet = "My Worksheet"
                    name = "esd.techprodc.com-products.xls">
                    <vs-button class="float-right" size="middle" color="success" type="filled">
                        {{ $t('ExportToExcel') }}
                    </vs-button>
                </download-excel>

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div></div>
                    <!-- ITEMS PER PAGE -->
                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" style="position: relative;z-index: 2;">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ products.from }} - {{ products.to }} of {{ products.total }} | Show {{ itemsPerPage }} entries</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=5"><span>5</span></vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=10"><span>10</span></vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=25"><span>25</span></vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50"><span>50</span></vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100"><span>100</span></vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col md:w-2/12 sm:w-12/12 w-full mb-5">
                <div class="sidebar" style="height: auto;">
                    <h6 class="font-bold mb-2">{{ $t('Brands') }}</h6>
                    <div v-for="(item, index) in filters" :key="index">
                        <ul>
                            <li class="mt-3">
                                <vs-radio v-model="brandRadio" :vs-value="item.id">{{ item.text}}</vs-radio>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sidebar mt-5" style="height: auto;">
                    <h6 class="font-bold mb-2">{{ $t('Categories') }}</h6>
                    <div v-for="(item, index) in filters" :key="index">
                        <ul>
                            <li class="mt-3" v-for="(item2, index) in item.categories" :key="index" v-if="brandRadio === item.id || brandRadio === 0">
                                <vs-radio v-model="categoryRadio" :vs-value="item2.id">{{ item2.text}}</vs-radio>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="sidebar mt-5" style="height: auto;">
                    <h6 class="font-bold mb-2">{{ $t('productName') }}</h6>
                    <vs-input class="inputx" v-model="title" style="width: auto" />
                </div>

                <div class="sidebar mt-5" style="height: auto;">
                    <vs-button color="primary" type="filled" @click="clearAll()">{{ $t('Clear') }}</vs-button>
                </div>
            </div>
            <div class="vx-col md:w-10/12 sm:w-12/12 w-full">
                <vs-table ref="table"
                          :sst="true"
                          :data="products.items"
                >

                    <template slot-scope="{data}">
                        <tbody ref="table_modal">
                            <tr v-for="(item, index) in data" :data="item" :key="item.id">
                                <vs-td class="list-view-item mb-base overflow-hidden" style="padding: 0;">
                                    <product-list-view :item="item" :checkout="false"></product-list-view>
                                </vs-td>
                            </tr>
                        </tbody>
                    </template>
                </vs-table>
                <div class="con-pagination-table vs-table--pagination" v-if="products.total > itemsPerPage">
                    <vs-pagination :key="paginateIndexKey" :total="products.last_page" :max-items="itemsPerPage" :size-array="products.total" v-model="page"></vs-pagination>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import ProductListView from '../components/ProductListView.vue';

    export default {
        components: {
            ProductListView
        },
        data() {
            return {
                userInfo: window.userInfo,
                items: [],
                brandRadio: 0,
                categoryRadio: 0,
                title: '',
                show: false,
                selected: [],
                itemsPerPage: 10,
                isMounted: false,
                filters: [],

                products: [],
                page: 1,
                paginateIndexKey: 1,

                checked: {
                    brand: '',
                    categories: '',
                    subcategories: ''
                },

                json_data: [],
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        watch: {
            brandRadio(){
                this.categoryRadio = 0;
                this.page = 1;
                this.getProducts();
            },
            categoryRadio: function () {
                this.page = 1;
                this.getProducts();
            },
            title: function () {
                this.page = 1;
                this.getProducts();
            },
            page: function () {
                this.getProducts();
            },
            itemsPerPage(stage){
                this.page = 1;
                localStorage.setItem('itemsPerPage', stage);
                window.itemsPerPage = stage;
                this.getProducts();
            }
        },
        methods: {
            clearAll() {
                this.brandRadio = 0;
                this.categoryRadio = 0;
                this.title = '';
            },
            getProducts(){
                this.$vs.loading();
                const thisIns = this;

                let _return = [];
                if (thisIns.userInfo.type_id === 3) {
                    let currentdate = new Date();
                    let datetime = currentdate.getDate() + "-" + (currentdate.getMonth() + 1) + "-" + currentdate.getFullYear() + " " + currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();
                    _return = [
                        {
                            ' ': '<b>Download date</b>',
                            '  ': datetime,
                            '   ': '',
                            '    ': '',
                        },
                        {
                            ' ': '<b>' + this.$t('PartnerStatus') + '</b>',
                            '  ': this.userInfo.markup ? this.userInfo.markup.title : '',
                            '   ': '',
                            '    ': '',
                        },
                        {
                            ' ': '',
                            '  ': '',
                            '   ': '',
                            '    ': '',
                        },
                        {
                            ' ': '<b>' + this.$t('sku') + '</b>',
                            '  ': '<b>' + this.$t('title') + '</b>',
                            '   ': '<b>' + this.$t('price') + '</b>',
                            '    ': '<b>' + this.$t('description') + '</b>',
                        }
                    ];
                }

                const params = {
                    length: this.itemsPerPage,
                    page: this.page,
                    token: token,
                    brand_id: this.brandRadio,
                    category_id: this.categoryRadio,
                    title: this.title,
                };
                const u = new URLSearchParams(params).toString();

                let url = apiUrl + '/products/all?token=' + token + '&' + u;
                if (this.userInfo.need_azn_cash){
                    url = apiUrl + '/products/azn/all?token=' + token + '&' + u;
                }

                axios.get(url)
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.products = data.data;

                            if (thisIns.userInfo.type_id === 3) {
                                for (let [key, item] of Object.entries(thisIns.products)) {
                                    _return.push({
                                        ' ': item.Sku,
                                        '  ': item.FullTitle,
                                        '   ': item.Amount + '$',
                                        '    ': item.Description,
                                    });
                                }

                                _return.push({
                                    ' ': '',
                                    '  ': '',
                                    '   ': '',
                                    '    ': '',
                                });

                                _return.push({
                                    ' ': thisIns.$t('excelText1'),
                                    '  ': thisIns.$t('excelText2'),
                                    '   ': '',
                                    '    ': '',
                                });

                                thisIns.json_data = _return;
                            }

                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }

                        thisIns.paginateIndexKey++;
                        thisIns.$vs.loading.close();
                    });
            }
        },
        created() {
            this.getProducts();

            const thisIns = this;
            axios.get(apiUrl + '/categories/getForFilter?token=' + token)
                .then(function (response) {
                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.filters = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                })
        },
        mounted() {
            this.isMounted = true;
        }
    }
</script>


<style lang="scss">

    .vs-checkbox-primary .vs-checkbox {
        margin-right: 10px !important;
    }

    .sidebar {
        background: #fff;
        width: 100%;
        height: 100vh;
        /*max-width: 260px;*/
        top: 38px;
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, .05);
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, .05);
        -webkit-transition: all .25s ease;
        transition: all .25s ease;
        z-index: 40000;
        padding: 1.5rem !important;
    }

    .active {

        path {
            fill: #d92121 !important;
        }
    }



    .ui-selected {
        background: rgba(var(--vs-primary), .05) !important;
        color: rgba(var(--vs-primary), 1);
        -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
        box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
    }

    .td-check {
        display: none !important;
    }

    #product-base {

        .vs-radio--label {
            padding-left: 10px;
        }

        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table--tbody-table{
                min-width: auto;
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                /*padding: 0 1rem;*/

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
